// Mock data for Sparky's Auto Electric website

export const businessInfo = {
  name: "Sparky's Auto Electric",
  address: "5000 SW 149th Ave, Beaverton, OR 97007",
  phone: "(503) 709-4366",
  rating: 4.8,
  hours: [
    { day: "Monday", time: "10:00 AM - 6:00 PM" },
    { day: "Tuesday", time: "10:00 AM - 6:00 PM" },
    { day: "Wednesday", time: "10:00 AM - 6:00 PM" },
    { day: "Thursday", time: "10:00 AM - 6:00 PM" },
    { day: "Friday", time: "10:00 AM - 6:00 PM" },
    { day: "Saturday", time: "10:00 AM - 6:30 PM" },
    { day: "Sunday", time: "10:00 AM - 6:00 PM" }
  ]
};

export const services = [
  {
    id: 1,
    title: "Electrical System Diagnostics",
    description: "Expert diagnosis of complex automotive electrical issues including wiring problems, sensor failures, and computer system malfunctions.",
    icon: "Zap"
  },
  {
    id: 2,
    title: "Battery & Alternator Service",
    description: "Complete battery testing, replacement, and alternator repair to keep your vehicle's electrical system running smoothly.",
    icon: "Battery"
  },
  {
    id: 3,
    title: "Starter & Ignition Repair",
    description: "Professional starter motor and ignition system repair for reliable engine starting in all conditions.",
    icon: "Power"
  },
  {
    id: 4,
    title: "Lighting Systems",
    description: "Complete headlight, taillight, and interior lighting repair and upgrade services.",
    icon: "Lightbulb"
  },
  {
    id: 5,
    title: "General Maintenance",
    description: "Oil changes, brake service, fluid checks, and all standard maintenance to keep your car running perfectly.",
    icon: "Wrench"
  },
  {
    id: 6,
    title: "Engine Diagnostics",
    description: "Advanced computer diagnostics and troubleshooting for check engine lights and performance issues.",
    icon: "Gauge"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Mitchell",
    rating: 5,
    text: "Skip is absolutely the most honest mechanic I've ever dealt with. He diagnosed my electrical issue in minutes and charged me fairly. No upselling, just straightforward service.",
    date: "2 weeks ago"
  },
  {
    id: 2,
    name: "Michael Torres",
    rating: 5,
    text: "Took my car to three other shops and nobody could figure out the electrical gremlin. Skip found it in an hour. Highly recommend for any complex electrical work!",
    date: "1 month ago"
  },
  {
    id: 3,
    name: "Jennifer Park",
    rating: 5,
    text: "Fair prices, honest assessment, and quality work. Skip told me what I actually needed vs what could wait. Refreshing to find a mechanic you can trust!",
    date: "3 weeks ago"
  },
  {
    id: 4,
    name: "David Chen",
    rating: 5,
    text: "Best auto shop in Beaverton. Skip's expertise in electrical systems is unmatched. Fixed my car right the first time at a very reasonable price.",
    date: "1 week ago"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Specialized Expertise",
    description: "We are experts in automotive electrical systems, diagnosing the complex wiring issues that stump standard mechanics.",
    icon: "Award"
  },
  {
    id: 2,
    title: "Comprehensive Care",
    description: "We do much more than just electric! From basic maintenance to under-the-hood diagnostics, we are your full-service local shop.",
    icon: "CheckCircle"
  },
  {
    id: 3,
    title: "Community Trusted",
    description: "Proudly holding a 4.8-star rating and recommended by locals as Beaverton's most honest mechanic.",
    icon: "Users"
  },
  {
    id: 4,
    title: "Honest Pricing",
    description: "No pressure, no gimmicks—just straightforward expertise. We believe in fixing only what needs to be fixed.",
    icon: "DollarSign"
  }
];
